import PropTypes from "prop-types";
import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import { useBankProvider } from "Payments/globalPaymentsStateHooks";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";

import SelectPaymentMethodPopover from "./SelectPaymentMethodPopover";

export default function AddPaymentMethodButton({
  setShowModal,
  setShowPlaidModal,
  isCardAllowed,
  isACHAllowed,
  setInitialPaymentType,
}) {
  const [showPopover, setShowPopover] = useState(false);
  const buttonRef = useRef();
  const { providerIsWePay: bankProviderIsWePay } = useBankProvider();
  // const bankProviderIsWePay = true;

  const buttonText = () => {
    return isCardAllowed && isACHAllowed
      ? "Add Payment Method"
      : isCardAllowed
      ? "Add Credit Card"
      : "Link Bank Account";
  };

  const handleClick = () => {
    if (isCardAllowed && isACHAllowed) setShowPopover(true);
    else if (isCardAllowed) setShowModal(true);
    else setShowPlaidModal(true);
  };

  const handleCardSelect = () => {
    setShowPopover(false);
    setInitialPaymentType("");
    setShowModal(true);
  };

  const handleACHSelect = () => {
    setShowPopover(false);
    if (bankProviderIsWePay) {
      setShowPlaidModal(true);
    } else {
      setInitialPaymentType("bank"); // used to force ACH entry form
      setShowModal(true);
    }
  };

  if (!isCardAllowed && !isACHAllowed) return null;

  return (
    <Wrapper ref={buttonRef}>
      <FnrButton color="green" onClick={handleClick}>
        <ButtonIcon fas fa-plus-circle />
        <ButtonText>{buttonText()}</ButtonText>
      </FnrButton>
      <SelectPaymentMethodPopover
        buttonRef={buttonRef}
        show={showPopover}
        setShow={setShowPopover}
        onCardSelect={handleCardSelect}
        onACHSelect={handleACHSelect}
      />
    </Wrapper>
  );
}

AddPaymentMethodButton.propTypes = {
  setShowModal: PropTypes.func,
  setShowPlaidModal: PropTypes.func,
  isCardAllowed: PropTypes.bool,
  isACHAllowed: PropTypes.bool,
  setInitialPaymentType: PropTypes.func,
};

const Wrapper = styled.div`
  text-align: center;

  button {
    margin: 0 auto;
  }
`;
